// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__udtzE","boxPrices":"styles_boxPrices__P46WL","priceSum":"styles_priceSum__oEm2r","priceTotal":"styles_priceTotal__uKxWo"};